import React from "react";
import PageContent from "2g-page-content";

import KonfiguracniParamteryEditaceWidget from "b2b/components/konfiguracni-parametry-editace-widget/KonfiguracniParamteryEditaceWidget";

export function KonfiguracniParametry() {
  return (
    <PageContent>
      <KonfiguracniParamteryEditaceWidget />
    </PageContent>
  );
}

KonfiguracniParametry.propTypes = {};

export default React.memo(KonfiguracniParametry);
